// extracted by mini-css-extract-plugin
export default {"registrationForm":"registration-module--registrationForm--3IB9s","content":"registration-module--content--1QeOM","textUnderline":"registration-module--textUnderline--FhAov"};